const useKnowledgeBase =
  ({ redirect, newPage = true }: { redirect?: string; newPage?: boolean }) =>
  () =>
    navigateToSupport(newPage, redirect || 'https://help.zscaler.com/secops');

const navigateToSupport = (newPage: boolean, url: string) => {
  if (newPage) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
};

export default useKnowledgeBase;
